<template>
  <div class="footer-box">
    <div class="container">
      <div class="row justify-content-center">

        <div class="footer-box__logo col-12 col-lg-3 offset-lg-1">
          <router-link :to="{name: 'home'}">
            <img src="@/images/logo-footer.png" />
          </router-link>
        </div>

        <div class="footer-box__button col-12 col-lg-2 order-lg-1">
          <!-- <router-link :to="{ name: 'inscrevase' }">
            <Button blue border>
              Inscreva-se
            </Button>
          </router-link> -->
        </div>

        <div class="footer-box__links col-12 col-lg-5">
          <ul class="row">
            <li class="col-12 col-sm-4 col-lg-6">
              <router-link :to="{ name: 'home' }" class="footer-box__link">
                Informações
              </router-link>
            </li>
            <li class="col-12 col-sm-4 col-lg-6">
              <router-link :to="{ name: 'percurso' }" class="footer-box__link">
                Percurso e Dicas
              </router-link>
            </li>
            <li class="col-12 col-sm-4 col-lg-6">
              <router-link :to="{ name: 'regulamento' }" class="footer-box__link">
                Regulamento
              </router-link>
            </li>
            <li class="col-12 col-sm-4 col-lg-6">
              <router-link :to="{ name: 'resultado' }" class="footer-box__link">
                Resultado
              </router-link>
            </li>
            <li class="col-12 col-sm-4 col-lg-6">
              <router-link :to="{ name: 'perguntasFrequentes' }" class="footer-box__link">
                Dúvidas
              </router-link>
            </li>
          </ul>
        </div>

        <div class="footer-box__copy col-12 order-lg-2">
          © Copyright Bradesco 2018. Todos direitos reservados
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/Button'

  export default {
    components: {
      Button,
    }
  }
</script>

<style lang="scss" scoped>
  .footer-box
  {
    padding: 25px 0;

    &__logo,
    &__button,
    &__links,
    &__copy
    {
      margin-top: 25px;
      margin-bottom: 25px;
    }

    &__logo,
    &__button,
    &__copy
    {
      text-align: center;
    }

    &__copy
    {
      font-size: 12px;
      font-weight: 300;
      line-height: 18px;

      color: #737373;
    }

    &__links
    {
      @media (max-width: 575px)
      {
        text-align: center;
      }
    }

    &__link
    {
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;

      display: inline-block;

      margin: 7px 0;

      color: #003862;
    }
  }
</style>
